import { Selector } from 'sonata-react-components';

import type { FilterConfig } from './filters.types';

type Props = {
  filters: FilterConfig[];
};

function FilterSelectors({ filters }: Readonly<Props>) {
  return (
    <div className="filters__container">
      {filters.map((filter, index) => (
        <div className="filters__item" key={index}>
          {filter.label && <span className="filters__label">{filter.label}</span>}
          <Selector onChange={filter.onChange} options={filter.options} tiny type="multiple" value={filter.value} />
        </div>
      ))}
    </div>
  );
}

export default FilterSelectors;
